module.exports = __webpack_public_path__ + "img/text-classify8_1.110a14e2.svg";